<template>
  <v-container fluid grid-list-md align-center pa-0>
    <ComponentAdminReportStudentLoan />
  </v-container>
</template>

<script>
import ComponentAdminReportStudentLoan from "@/components/admin/ComponentAdminReportStudentLoan";
export default {
  components: {
    ComponentAdminReportStudentLoan
  }
};
</script>

<style scoped></style>
